import Image from 'next/image';

export function CartIcon() {
    return (
        <Image src="/icons/cart-icon.svg" alt="Cart Icon" width={20} height={20} />
    );
}
